import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useTheme } from "../../theme";
import GoogleLogo from "../shared/GoogleLogo";

const SignIn = (props) => {
  const { p, d, fonts } = useTheme();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [errors, setErrors] = useState(false);
  const [user, setUser] = useState(!!localStorage.getItem("token"));
  const [googleLoading, setGoogleLoading] = useState(false);
  const [googleMsg, setGoogleMsg] = useState('');
  const [forgotMsg, setForgotMsg] = useState('');
  const googleTimer = useRef(null);
  const forgotTimer = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => () => { clearTimeout(googleTimer.current); clearTimeout(forgotTimer.current); }, []);

  function handleGoogle() {
    if (googleLoading) return;
    setGoogleLoading(true);
    setGoogleMsg('');
    setTimeout(() => {
      setGoogleLoading(false);
      setGoogleMsg('Google authentication is currently unavailable. Please sign in with your username and password.');
      googleTimer.current = setTimeout(() => setGoogleMsg(''), 4000);
    }, 1500);
  }

  function handleForgot() {
    setForgotMsg('Password reset is currently unavailable. Please contact support.');
    forgotTimer.current = setTimeout(() => setForgotMsg(''), 4000);
  }

  function handleClick() {
    axios
      .post(`${process.env.REACT_APP_API_URL}/api/token/login`, {
        password: password,
        username: username,
      })
      .then((response) =>
        props.handleToken(response.data["auth_token"], setUser(true))
      )
      .catch(function (error) {
        if (error.response) {
          setErrors(true);
        }
      });
  }

  useEffect(() => {
    if (user) navigate(location.state ? location.state.from.pathname : "/");
  }, [user, navigate, location.state]);

  const inputStyle = {
    width: '100%',
    background: 'transparent',
    border: 'none',
    outline: 'none',
    fontFamily: fonts.mono,
    fontSize: 14,
    color: p.textHi,
    caretColor: p.accent,
    flex: 1,
  };

  return (
    <div style={{ minHeight: '100%', background: p.bg, color: p.text, fontFamily: fonts.sans }}>
      <section style={{ padding: `${d.hero * 0.6}px ${d.pad}px`, display: 'grid', placeItems: 'center' }}>
        <div style={{ width: '100%', maxWidth: 440, border: `1px solid ${p.border}`, background: p.bgPanel }}>
          {/* header bar */}
          <div style={{
            padding: '12px 22px', borderBottom: `1px solid ${p.border}`,
            fontFamily: fonts.mono, fontSize: 11, color: p.textDim, letterSpacing: '.12em',
            display: 'flex', justifyContent: 'space-between',
          }}>
            <span><span style={{ color: p.accent }}>●</span> /auth/signin</span>
            <span>SECURE</span>
          </div>

          <div style={{ padding: '36px 36px 30px' }}>
            <h2 style={{
              fontFamily: fonts.serif, fontSize: 36, fontWeight: 400,
              letterSpacing: '-.02em', margin: '0 0 6px', color: p.textHi,
            }}>Sign in</h2>
            <div style={{
              fontFamily: fonts.serif, fontStyle: 'italic', fontSize: 14,
              color: p.textDim, marginBottom: 28,
            }}>continue your journey</div>

            {errors && (
              <div style={{
                padding: '10px 14px', marginBottom: 18,
                border: `1px solid ${p.rose}`, color: p.rose,
                fontFamily: fonts.mono, fontSize: 12,
              }}>
                Invalid username and/or password
              </div>
            )}

            {/* username */}
            <label style={{
              display: 'block', fontFamily: fonts.mono, fontSize: 10,
              letterSpacing: '.14em', color: p.textDim, textTransform: 'uppercase', marginBottom: 8,
            }}>USERNAME</label>
            <div style={{
              border: `1px solid ${p.borderHi}`, padding: '12px 14px', marginBottom: 16,
              fontFamily: fonts.mono, fontSize: 14, display: 'flex', alignItems: 'center', gap: 8,
            }}>
              <span style={{ color: p.accent }}>›</span>
              <input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="your username"
                style={inputStyle}
              />
            </div>

            {/* password */}
            <label style={{
              display: 'block', fontFamily: fonts.mono, fontSize: 10,
              letterSpacing: '.14em', color: p.textDim, textTransform: 'uppercase', marginBottom: 8,
            }}>PASSWORD</label>
            <div style={{
              border: `1px solid ${p.borderHi}`, padding: '12px 14px', marginBottom: 14,
              fontFamily: fonts.mono, fontSize: 14, display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1 }}>
                <span style={{ color: p.accent }}>›</span>
                <input
                  type={showPw ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleClick()}
                  placeholder="••••••••"
                  style={inputStyle}
                />
              </div>
              <span
                onClick={() => setShowPw(!showPw)}
                style={{ color: p.textDim, cursor: 'pointer', fontSize: 12, userSelect: 'none' }}
              >{showPw ? 'hide' : 'show'}</span>
            </div>

            <div
              onClick={handleForgot}
              style={{
                fontFamily: fonts.mono, fontSize: 11, color: p.accent,
                marginBottom: forgotMsg ? 10 : 22, letterSpacing: '.05em', cursor: 'pointer',
              }}
            >
              [forgot password?]
            </div>

            {forgotMsg && (
              <div style={{
                padding: '10px 14px', marginBottom: 18,
                border: `1px solid ${p.warn}`, color: p.warn,
                fontFamily: fonts.mono, fontSize: 12,
              }}>
                {forgotMsg}
              </div>
            )}

            <div
              onClick={handleClick}
              style={{
                padding: '14px 0', textAlign: 'center',
                background: p.accent, color: p.bg,
                fontFamily: fonts.mono, fontSize: 13, fontWeight: 500,
                letterSpacing: '.08em', cursor: 'pointer',
              }}
            >SIGN IN ↵</div>

            {/* divider */}
            <div style={{
              display: 'flex', alignItems: 'center', gap: 14,
              margin: '20px 0 16px',
            }}>
              <span style={{ flex: 1, borderTop: `1px dashed ${p.border}` }} />
              <span style={{ fontFamily: fonts.mono, fontSize: 11, color: p.textDim, letterSpacing: '.08em' }}>or</span>
              <span style={{ flex: 1, borderTop: `1px dashed ${p.border}` }} />
            </div>

            <div
              onClick={handleGoogle}
              style={{
                padding: '13px 0', textAlign: 'center',
                border: `1px solid ${p.borderHi}`, background: 'transparent',
                fontFamily: fonts.mono, fontSize: 13, letterSpacing: '.06em',
                color: p.text, cursor: 'pointer',
                display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10,
                opacity: googleLoading ? 0.6 : 1,
                transition: 'opacity .15s',
              }}
            >
              {googleLoading ? (
                <span style={{ color: p.textDim }}>CONNECTING...</span>
              ) : (
                <><GoogleLogo size={18} /> SIGN IN WITH GOOGLE</>
              )}
            </div>

            {googleMsg && (
              <div style={{
                padding: '10px 14px', marginTop: 12,
                border: `1px solid ${p.warn}`, color: p.warn,
                fontFamily: fonts.mono, fontSize: 12,
              }}>
                {googleMsg}
              </div>
            )}

            <div style={{
              marginTop: 22, paddingTop: 20, borderTop: `1px dashed ${p.border}`,
              textAlign: 'center', fontSize: 13, color: p.textDim,
            }}>
              new to usertags?{' '}
              <NavLink to="/signup" style={{
                color: p.accent, fontFamily: fonts.mono, fontSize: 12,
                textDecoration: 'none',
              }}>[join now →]</NavLink>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SignIn;
